// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'

import { routes } from 'app_routers/AppRoutingRoute'
// @end

// @import components
import {BreadcrumbCommonLayout, BreadcrumbLinksCommonLayout} from 'app_components/commons/breadcrumb'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IBreadcrumbCommonProps {
  texts: string[]
  links?: any[]
}
interface IBreadcrumbCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BreadcrumbCommon extends Component<IBreadcrumbCommonProps, IBreadcrumbCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBreadcrumbCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <React.Fragment>
        {
          (!this.props.links)
            ?
            <BreadcrumbCommonLayout routes={routes} texts={this.props.texts} />
            :
            <BreadcrumbLinksCommonLayout links={this.props.links} texts={this.props.texts} />
        }
      </React.Fragment>
    )
  }
}

export default connect(mapStatesToProps)(BreadcrumbCommon)
